import InvoiceHistoryItem from './InvoiceHistoryItem';

export default InvoiceHistoryItem;
